import React, { Suspense, lazy, useEffect } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import ReactGA from 'react-ga4'

// Lazy load the ContactForm component
const ContactForm = lazy(() => import('../components/ContactForm'))

const Contact = () => {
  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname })
  }, [])

  return (
    <div className='page-content'>
      <div className='shapy-background'>
        <Header />
        <div
          className='contact-page-container'
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingTop: '120px', // Add more space between header and content
            paddingBottom: '40px'
          }}
        >
          <Suspense fallback={
            <div className="contact-form-placeholder">
              <h2 className="contact-heading">Get in Touch</h2>
              <hr />
              <div className="form-loading">
                <div className="loading-spinner-large"></div>
                <p>Loading contact form...</p>
              </div>
            </div>
          }>
            <ContactForm />
          </Suspense>
        </div>
        <Footer />
      </div>
    </div>
  )
}

export default Contact
